
import AppSidebar from "@/components/Sidebar/AppSidebar.vue";
import AddFarmButton from "@/components/AddFarmButton.vue";
import { gettersInstance, isMobile } from "../../lib/util";
import { Component, MixedVue, mixins } from "@/vue";
import { Watch } from "vue-property-decorator";
import { Route } from "vue-router";

const StoreGetters = gettersInstance([
  "user",
  "showAppSidebar",
  "farmsWithSeasons",
  "currentFarm",
  "isDemoFarm",
  "parcelsForCurrentSeason",
  "showSearchSidebar",
  "allFarms",
]);

@Component({
  name: "AppSidebarTransition",
  components: { AddFarmButton, AppSidebar },
})
export default class AppSidebarTransition extends mixins(MixedVue, StoreGetters) {
  static components: {
    AddFarmButton: typeof AddFarmButton;
    AppSidebar: typeof AppSidebar;
  };

  $refs: {
    appSidebar: AppSidebar;
  };

  drawerDisplayed: boolean = false;
  farmPickerDisplayed: boolean = false;

  get newAccountRoute() {
    const ref = this.currentFarm ? (this.isDemoFarm ? "demo_farm" : "shared_farm") : "shared_parcel";
    return { name: "new-account", query: { ref } };
  }

  @Watch("$route")
  $routeChanged(toRoute: Route) {
    if (toRoute.name == "map" && isMobile()) {
      let farmId = toRoute.params.farmId;
      if (this.allFarms[farmId]?.parcel_count == 0) {
        return;
      }
    }
    this.$nextTick(() => {
      this.$store.commit("setShowAppSidebar", false);
    });
  }

  @Watch("$showAppSidebar")
  showAppSidebarChanged(to: boolean) {
    if (to) {
      document.addEventListener("keyup", this.handleKeyUp);
    } else {
      document.removeEventListener("keyup", this.handleKeyUp);
    }
  }

  maybeHideSidebar(focusEvent?: FocusEvent) {
    if (this.isMobile && this.currentFarm && this.currentFarm.parcel_count === 0) {
      return;
    }
    if (this.showSearchSidebar) {
      return;
    }
    if (!this.$refs.appSidebar || !focusEvent || !focusEvent.relatedTarget || !this.$refs.appSidebar.$el.contains(focusEvent.relatedTarget as HTMLElement)) {
      this.$store.commit("setShowAppSidebar", false);
    }
  }

  handleKeyUp(e: KeyboardEvent) {
    if (e.key == "Escape") {
      this.maybeHideSidebar();
    }
  }
}
